import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  deBaja: {
    backgroundColor: "red",
    paddingLeft: 25,
  },
  deAlta: {
    backgroundColor: "green",
    paddingLeft: 25,
  },
  disca: {
    backgroundColor: "#4FE3E3",
    paddingLeft: 25,
  },
  sinFicha: {
    backgroundColor: "#FFFF00",
    paddingLeft: 25,
  },
  divContenedor: {
    display: "flex",
    justifyContent: "space-between",
  },
  turnos: {
    fontSize: 14
  },
  contratos: {
    fontSize: 17,
    color: "white"
  },
}));

export const BannerAfiliadoWeb = () => {

  const classes = useStyles();
  const preinscripto = useSelector((state) => state.preinscripto);
  const afiliado = preinscripto.afiliadoEncontrado;

  const seccional = useSelector(state =>
    state.seccionales.items.find((sec) => sec?.id_seccional === afiliado?.domiciliosAfiliados?.id_seccional)
  );
    console.log(afiliado);
  return (
    <Grid container className={classes.divContenedor} spacing={1}>
      <Grid item xs={6}>
        <Paper
          className={classes.deAlta}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
            }}
            variant={"subtitle1"}
            component={"p"}
          >
            {
              `${afiliado?.apellido_y_nombre} / CUIL: ${afiliado?.cuil}`
            }
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper
          className={afiliado?.fecha_baja ? classes.deBaja : (afiliado?.sinFichaAfiliacion ? classes.sinFicha : (afiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
            }}
            variant="subtitle1"
          >
            {seccional && `Seccional: ${seccional?.descripcion_seccional}`}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper
          className={classes.deAlta}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
            }}
            variant="subtitle1"
          >
            {`C.P: ${afiliado?.domiciliosAfiliados?.codigo_postal} `}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};